export const APPLE_ACCOUNT_TASK_INDEX = 0;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const APPLE_ACCOUNT_TASK_NAME = 'ACT App - Apple Account Email';

export function normalizeAppleAccountEmail(value) {
  return typeof value === 'string'
    ? value.trim().toLowerCase().slice(0, 320)
    : '';
}

export function isValidAppleAccountEmail(value) {
  const normalizedEmail = normalizeAppleAccountEmail(value);
  return normalizedEmail.length > 0 && EMAIL_PATTERN.test(normalizedEmail);
}

export function getAppleAccountEmail(user) {
  const profileEmail = normalizeAppleAccountEmail(user?.appleAccountEmail);
  if (isValidAppleAccountEmail(profileEmail)) {
    return profileEmail;
  }

  const taskEmail = normalizeAppleAccountEmail(
    user?.tasks?.[APPLE_ACCOUNT_TASK_INDEX]?.response
  );
  return isValidAppleAccountEmail(taskEmail) ? taskEmail : '';
}

export function getAppleAccountEmailUpdatedAt(user) {
  if (!getAppleAccountEmail(user)) {
    return null;
  }

  return user?.appleAccountEmailUpdatedAt
    || user?.tasks?.[APPLE_ACCOUNT_TASK_INDEX]?.timestamp
    || null;
}

export function isOnboardingTaskComplete(task, taskIndex) {
  if (!task?.completed) {
    return false;
  }

  if (taskIndex === APPLE_ACCOUNT_TASK_INDEX) {
    return isValidAppleAccountEmail(task.response);
  }

  return true;
}

export function calculateOnboardingProgress(tasks) {
  if (!Array.isArray(tasks) || tasks.length === 0) {
    return 0;
  }

  const completedCount = tasks.filter((task, index) => (
    isOnboardingTaskComplete(task, index)
  )).length;

  return (completedCount / tasks.length) * 100;
}

export function getOnboardingTaskName(task, taskIndex) {
  return taskIndex === APPLE_ACCOUNT_TASK_INDEX
    ? APPLE_ACCOUNT_TASK_NAME
    : task?.taskName;
}
